import Cookies from 'js-cookie';

import { getCookieDomain } from '~/domains/auth/utils/getCookieDomain';

function removeTokens() {
  const domain = getCookieDomain();

  // Remove host-only cookies (legacy) and domain-scoped cookies
  Cookies.remove('accessToken');
  Cookies.remove('accessToken', { domain });
  Cookies.remove('refreshToken');
  Cookies.remove('refreshToken', { domain });
  Cookies.remove('isLoggedIn', { domain: '.splashsports.com' });
  const storageNames = ['sessionStorage', 'localStorage'] as const;
  storageNames.forEach((storageName) => {
    try {
      window[storageName].clear();
    } catch {} // eslint-disable-line no-empty -- Unavailable caches must not interrupt session cleanup.
  });
}

export { removeTokens };
